import { render } from "./AsyncMessagesSummary.vue?vue&type=template&id=4cd0dea9"
import script from "./AsyncMessagesSummary.vue?vue&type=script&lang=js"
export * from "./AsyncMessagesSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__